import React from 'react'
import user from '../../images/image (32).png'
import userAvatar from '../../images/user-avatar (1) 9.png'
const SharingFile = () => {
    return (
        <>
            <div className='file_sharing_wrapper'>
                <div className='storage_wrapper'>
                    <div className='storage_1'>
                        <p>Storage</p>
                        <h4>59 <span>GB</span></h4>
                        <h6>of 250 GB used  <span>Upgrade Plan</span></h6>
                    </div>


                    <div className='storage_1'>
                        <p>Files</p>
                        <h4>250</h4>
                        <h6>Manage Files </h6>
                    </div>


                    <div className='storage_1'>
                        <p>Views <span>Downloads</span></p>
                        <h5>400 <span>320</span></h5>
                        <h6>View Stats </h6>
                    </div>
                </div>

                <h2 className='recent_shared_head'>Recent Shares</h2>

                <div className='file_sharing_table_Wrapper'>
                    <table className='file_sharing_table'>
                        <thead className='file_sharing_thead'>
                            <tr>
                                <th>Name</th>
                                <th>Size</th>
                                <th>Members</th>
                                <th>Uploaded</th>
                                <th style={{
                                    width: '200px',
                                    minWidth: '200px'
                                }}>Downloads</th>
                                <th style={{
                                    width: 'auto',
                                    minWidth: 'auto'
                                }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((e, i) => {
                                return (
                                    <>
                                        <tr>
                                            <td><div className='file_sharing_checkbox_wrapper'>
                                                <input type='checkbox' />
                                                <div className='file_sharing_image_wrapper'>
                                                    <i class="fa-solid fa-image"></i>
                                                    <p>Overhills.jpg</p>
                                                </div>
                                            </div></td>

                                            <td>0.9 MB</td>
                                            <td>
                                                <div className='user_circle_div_wrapper' >
                                                    <img className='user_img' src={user} />
                                                    <img className='user_img' src={user} />
                                                    <img className='user_img' src={user} />

                                                    <p style={{
                                                        marginBottom: '0px',
                                                    }}>50</p>

                                                </div>
                                            </td>
                                            <td>
                                                20.5.25
                                            </td>
                                            <td>
                                                345
                                            </td>
                                            <td>
                                                <img src={userAvatar} style={{
                                                    width: '15px'
                                                }} />
                                            </td>
                                        </tr>
                                    </>
                                )
                            })}

                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default SharingFile
